const isProtectedImageTarget = (target) => {
  if (!(target instanceof Element)) {
    return false;
  }

  if (target.tagName !== 'IMG') {
    return false;
  }

  return Boolean(target.closest('media-gallery, .card-gallery, .product-media'));
};

document.addEventListener(
  'contextmenu',
  (event) => {
    if (isProtectedImageTarget(event.target)) {
      event.preventDefault();
    }
  },
  { capture: true }
);
